import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token') || null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo && token) {
      try {
          setUser(JSON.parse(userInfo));
      } catch (e) {
          console.error("Gagal parse userInfo dari localStorage:", e);
          localStorage.removeItem('userInfo');
          localStorage.removeItem('token');
          setToken(null);
      }
    }
    setLoading(false);
  }, [token]);

  const updateUserContext = (updatedUserData) => {
    localStorage.setItem('token', updatedUserData.token);
    localStorage.setItem('userInfo', JSON.stringify(updatedUserData));
    setToken(updatedUserData.token);
    setUser(updatedUserData);
  };

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/users/login`, {
        email,
        password,
      });
      
      const { data } = response;
      localStorage.setItem('token', data.token);
      localStorage.setItem('userInfo', JSON.stringify(data));
      setToken(data.token);
      setUser(data);
      navigate('/', { 
        replace: true, 
        state: { message: `Selamat datang kembali, ${data.name}!` } 
      });
    } catch (error) {
      console.error("Login failed:", error);
      throw error;
    }
  };

  // Fungsi untuk Logout
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    setToken(null);
    setUser(null);
    navigate('/login'); // Redirect ke halaman login
  };

  const value = { user, token, loading, login, logout, updateUserContext };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthContext;